import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import Cookies from "js-cookie";
import { useParams, useNavigate } from "react-router-dom";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { useFcmToken } from "./firebase/getFcmToken";
import { sendFcmToken } from "./services/api";
import { useLocation } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const fcmToken = useFcmToken();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const signIn = useSignIn();
  const location = useLocation();
  const currentPath = location.pathname;
  const { chargePointId } = useParams();

  useEffect(() => {
    if (!isAuthenticated) {
      if (currentPath.includes("pair-device")) {
        localStorage.setItem("currentUrl", currentPath);
      }
      const token = Cookies.get("token");
      if (token) {
        if (
          signIn({
            auth: {
              token,
              type: "Bearer",
              expiresIn: 7 * 24 * 60 * 60,
            },
          })
        ) {
          Cookies.remove("token");
          const storedUrl = localStorage.getItem("currentUrl");
          if (storedUrl) {
            navigate(storedUrl);
          } else {
            navigate("/");
          }
          localStorage.removeItem("currentUrl");
        } else {
          if (chargePointId === "9E0E85720-0" || chargePointId === "9E0EAB4BC-0" || chargePointId === "9E0EAB4BC-1" || chargePointId === "E6E3F5DF8-0") {
            navigate(`/demo-page?chargePointId=${chargePointId}`);
          } else {
            navigate("/login");
          }
        }
      } else {
        if (chargePointId === "9E0E85720-0" || chargePointId === "9E0EAB4BC-0" || chargePointId === "9E0EAB4BC-1" || chargePointId === "E6E3F5DF8-0") {
          navigate(`/demo-page?chargePointId=${chargePointId}`);
        } else {
          navigate("/login");
        }
      }
    }
    const cookieFcmToken = Cookies.get("fcmToken");
    if (!cookieFcmToken) {
      if (fcmToken) {
        sendFcmToken(fcmToken)
          .then(() => {
            Cookies.set("fcmToken", fcmToken);
          })
          .catch((error) => {
            console.error("Error sending FCM token:", error);
          });
      }
    }

    if (localStorage.getItem("currentUrl") && location.pathname === "/") {
      const storedUrl = localStorage.getItem("currentUrl");
      navigate(storedUrl);
      localStorage.removeItem("currentUrl");
    }
  }, [fcmToken, isAuthenticated, navigate, signIn, chargePointId, currentPath, location.pathname]);

  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
